module.exports = __webpack_public_path__ + "static/media/img18.b57123ab.jpg";